import { render, staticRenderFns } from "./BrandDiscountsLevels.vue?vue&type=template&id=6f2e31a3"
import script from "./BrandDiscountsLevels.vue?vue&type=script&lang=js"
export * from "./BrandDiscountsLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports